module.exports = __webpack_public_path__ + "img/bg.0522d563.jpg";